import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { catchError, EMPTY, Observable, Subject, switchMap, tap, throwError } from 'rxjs';
import { LocalStorageService } from '../local-storage.service';
import { Router } from '@angular/router';
import { LoginService } from '../../features/login/login.service';
import { RefreshTokenRequest, Tokens } from '../../features/login/login';
import { ToastService } from '../../core/toast/toast.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

  private isRefreshing: boolean = false;

  private httpRequestMaker$: Subject<void> = new Subject<void>();
  private retries: number = 0;
  private maxRetry: number = 4;
  private delayTime: number = 2000;

  constructor(private localStorageService: LocalStorageService,
    private userService: LoginService,
    private route: Router,
    private toastService: ToastService,
  ) {

    this.httpRequestMaker$.subscribe(() => {
      console.log("STARTING HTTP REQUEST")
    });

  }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(response => {
        console.log(JSON.stringify(response));
        //this.store.dispatch(new spinnerActions.SpinnerHidden({ senderID: '', requestID: request.method, visible: false }));
      }),
      catchError((err: HttpErrorResponse) => {
        console.error(err);

        let tokens = this.localStorageService.getTokens();

        if (request.url.includes('refresh-token') && err.status == 400) {
          this.isRefreshing = false;
          localStorage.clear();
          this.route.navigate(['/login', { tokenExpired: true }]);
          return throwError(() => new Error("Token refresh failed"));
        }

        if (err.status == 401) {
          if (this.isRefreshing == false && tokens) {
            this.isRefreshing = true;
            console.log(" \n \n \n \n \n Token expired, now refreshing... \n \n \n \n \n");

            let data: RefreshTokenRequest = {
              refreshToken: tokens.refreshToken
            };

            return this.userService.refreshToken(data).pipe(
              switchMap((response: Tokens) => {
                this.localStorageService.saveTokens(response);

                const clonedRequest = request.clone({
                  setHeaders: { Authorization: `Bearer ${response.accessToken}` }
                });



                this.isRefreshing = false;
                this.httpRequestMaker$.next();
                return next.handle(clonedRequest);
              }),
              catchError((error) => {
                return throwError(() => error);
              })
            );
          } else if (!tokens && this.isRefreshing == false) {
            //console.warn(session);
            console.error('Invalid session');
            tokens = this.localStorageService.getTokens();

            if (!tokens) {
              localStorage.clear();
              this.route.navigate(['/login']);
            }
          } else {
            if (this.retries <= this.maxRetry) {
              return this.httpRequestMaker$.pipe(
                switchMap(() => next.handle(this.addTokenHeader(request)))
              );
            } else {
              let errRisp: HttpErrorResponse = err.error;
              console.log(JSON.stringify(errRisp));
              return throwError(() => errRisp);
            }
          }
        } else {
          if (this.isRefreshing == false) {
            let errRisp: HttpErrorResponse = err.error;
            console.log(JSON.stringify(errRisp));
            return throwError(() => errRisp);
          }
        }
        return EMPTY;
      })
    );
  }

  private addTokenHeader(request: HttpRequest<any>) {
    return request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + this.localStorageService.getTokens()?.accessToken),
    });
  }
}

export const ErrorInterceptorProvider = { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true };
